/**
 * Resolve store content for the active UI language (manual admin translations).
 */
export function getLocalizedStore(store, languageCode) {
  if (!store) {
    return {
      name: "",
      description: "",
      logoAlt: "",
      seo: {},
      faqs: [],
      pageTitle: "",
    };
  }

  const lang = String(languageCode || "en");
  const base = lang.split("-")[0];
  const tx =
    store.languageTranslations?.[lang] ||
    store.languageTranslations?.[base] ||
    null;

  const seo = {
    ...(store.seo || {}),
    ...(tx?.seo || {}),
    h1: tx?.seoH1 || tx?.seo?.h1 || store.seo?.h1 || store.name,
    intro: tx?.seoIntro || tx?.seo?.intro || store.seo?.intro || "",
    title: tx?.seo?.title || tx?.metaTitle || store.seo?.title || "",
    description:
      tx?.seo?.description || tx?.metaDescription || store.seo?.description || "",
  };

  const faqs =
    tx?.faqs?.length > 0 ? tx.faqs : store.faqs?.length ? store.faqs : [];

  const displayName = tx?.name || store.name;

  return {
    name: displayName,
    description: tx?.description || store.description || "",
    logoAlt: tx?.logoAlt || store.logoAlt || `${displayName} logo`,
    seo,
    faqs,
    pageTitle: seo.h1 || displayName,
  };
}

/**
 * Resolve coupon fields for the active UI language.
 */
export function getLocalizedCoupon(coupon, languageCode) {
  if (!coupon) return coupon;
  const lang = String(languageCode || "en");
  const baseLang = lang.split("-")[0];
  const tx =
    coupon.languageTranslations?.[lang] ||
    coupon.languageTranslations?.[baseLang];
  if (!tx) return coupon;

  const features =
    tx.features?.length > 0 ? tx.features : coupon.features;

  return {
    ...coupon,
    title: tx.title || coupon.title,
    description: tx.description || coupon.description,
    details: tx.details || coupon.details,
    features: features || [],
    expiresAt: tx.expiresAt || coupon.expiresAt,
    discountValue: tx.discountValue || coupon.discountValue,
    originalPrice: tx.originalPrice || coupon.originalPrice,
    salePrice: tx.salePrice || coupon.salePrice,
    seo: {
      ...(coupon.seo || {}),
      title: tx.metaTitle || tx.seo?.title || coupon.seo?.title,
      description: tx.metaDescription || tx.seo?.description || coupon.seo?.description,
      keywords: tx.keywords || coupon.seo?.keywords,
      focusKeyword: tx.focusKeyword || coupon.seo?.focusKeyword,
      canonicalUrl: tx.canonicalUrl || coupon.seo?.canonicalUrl,
      ogImage: tx.ogImage || coupon.seo?.ogImage,
      robots: tx.robots || coupon.seo?.robots,
    },
  };
}
